import { createAction, props } from '@ngrx/store';
import { Ask } from '../../models/ask.model';// Ensure 'Ask' is correctly imported with the correct capitalization

// Action to load community ask
export const loadCommunityAsk = createAction(
  '[Product] Load Ask'
);

// Action to handle successful loading of community ask data
export const loadCommunityAskSuccess = createAction(
  '[Product] Load Ask Success',
  props<{ ask: Ask[] }>() // Correct type reference, array of 'Ask' objects
);

// Action to handle failure in loading community ask data
export const loadCommunityAskFailure = createAction(
  '[Product] Load Ask Failure',
  props<{ error: any }>()
);
